import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { StyledProps } from '.';

export const StyledFilter = styled.div`
  display: flex;
  width: 348px;
  height: 30px;
  border: 1px solid #00bf00;
  border-radius: 50px;
  gap: 1px;

  & > div:not(:last-child) {
    border-right: 1px solid #00bf00;
  }
`;

export const ConditionsSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  @media (max-width: 412px) {
    flex-direction: column !important;
  }
`;
export const SearchKeyConditionSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  & > div {
    background-color: #ffffff;
    &[data-type='text'] {
      margin: 0 10px;
    }
  }

  & img {
    position: absolute;
    right: 26px;

    &:hover {
      cursor: pointer;
    }
  }
`;
export const DateConditionSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 10px;
  & > div {
    background-color: #ffffff;
  }
  & > .logdaterange {
    background-color: unset;
  }
  & > section {
    background-color: #ffffff;
    border-radius: 4px;
    margin-left: 0;
  }

  & .logdaterange {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px auto;
  input:focus::-webkit-input-placeholder {
    visibility: hidden;
  }
  &.log {
    width: 100%;
    justify-content: space-between;

    & > div {
      margin: unset;
    }
  }

  & > .reset {
    position: relative;
    right: 0;
    color: #555;
    border-color: #555;
  }

  @media (max-width: 412px) {
    flex-direction: column !important;
    section {
      flex-direction: column !important;
    }
    section,
    div {
      margin: 5px 0 !important;
      width: 100%;
    }
  }
  ${(props: StyledProps) => props.styles};
`;
export const FilterSearchConditionStyle = css`
  width: 160px;
  height: 40px;
`;
export const FilterSearchKeywordStyle = css`
  width: 200px;
  height: 40px;
`;
export const FilterDateRangeStyle = css`
  width: 200px;
  height: 40px;
  box-sizing: border-box;
  & > input {
    height: 40px;
    border: unset;
    color: #555555;
    padding-left: 16px;
    width: 100%;

    &::-webkit-input-placeholder {
      text-align: left;
      font-family: Noto Sans KR;
      font-style: normal;
      font-weight: normal;
      letter-spacing: normal;
      font-size: 14px;
    }
  }
  position: relative;
`;

export const FilterDateRangeNoMarginStyle = css`
  width: 200px;
  height: 40px;
  margin: 0;
  box-sizing: border-box;
  & > input {
    height: 40px;
    border: unset;
    color: #555555;
    padding-left: 16px;
    width: 100%;

    &::-webkit-input-placeholder {
      text-align: left;
      font-family: Noto Sans KR;
      font-style: normal;
      font-weight: normal;
      letter-spacing: normal;
      font-size: 14px;
    }
  }
  position: relative;
`;

export const FilterSearchButtonStyle = css`
  width: 140px;
  height: 40px;
`;

export const FilterEchoButtonStyle = css`
  width: 114px;
  height: 36px;
  font-weight: 700;
  font-size: 14px;
`;

export const StyledSettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  padding-left: 32px;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
`;

export const StyledInputList = styled.ul`
  position: relative;
  &.result-list {
    display: block;
    & li {
      display: block;
      margin-bottom: 20px;
    }
  }

  & li {
    display: inline-block;
    margin: 10px 40px 10px 0;
  }
`;
